export const getInitialValueTranslate = () =>
	window.localStorage.getItem('language');

export const addInitialValueTranslate = (language: any) =>
	window.localStorage.setItem('language', language);

export const getInitialTimeZone = () => window.localStorage.getItem('timeZone');

export const addInitialTimeZone = (timeZone: string) =>
	window.localStorage.setItem('timeZone', timeZone);
